module.exports = __webpack_public_path__ + "static/media/ug.69ed4876.svg";